module.exports = __webpack_public_path__ + "img/Logo-menschen.976329b7.png";